import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";
import available_countries_options from "utils/select_options/available_countries";

import { Dashboard, Select } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const BasicData = ({
  vat_rate_id,
  refetch,
  initialValues,
  handleSubmit,
  change,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/vat_rates/${vat_rate_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer", "brand", "root_taxon"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              name="country_code"
              label="Kraj"
              handleChange={(value) => change("country_code", value)}
              component={SelectField}
              defaultValue={available_countries_options.find(
                ({ value }) => value === initialValues.country_code
              )}
              options={available_countries_options}
            />
          </div>
          <div className="box-6">
            <Field
              name="name"
              label="Nazwa"
              component={InputField}
              type="text"
            />
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              name="value"
              label="Stawka"
              component={InputField}
              postfix="%"
              type="number"
            />
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  if (!values.producer_id) {
    errors.producer_id = "Producent jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "update-brand-basic",
  enableReinitialize: true,
  validate,
})(BasicData);